import Vue from 'vue'
import {
  Button,
  Input,
  Select,
  Option,
  DatePicker,
  Upload,
  Menu,
  Submenu,
  MenuItem,
  Form,
  FormItem,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Tooltip,
  Popover,
  Loading,
  Scrollbar,
  Message,
  MessageBox,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Pagination,
  CheckboxGroup,
  Checkbox,
  Autocomplete,
  Radio,
  RadioGroup,
  Tree,
  Switch,
  Drawer,
  Link,
  ButtonGroup,
} from 'element-ui'

import waterfall from 'vue-waterfall2'

// import '@/assets/styles/theme/element-variables.scss'

// import AkeDialog from '@/components/dialog'

import BasicTableComp from '@/components/basic_table'
import BasicDrawerComp from '@/components/basic_drawer'

Vue.prototype.$ELEMENT = { size: 'small' }

Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(Scrollbar)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Pagination)
Vue.use(Autocomplete)
Vue.use(Tree)
Vue.use(Switch)
Vue.use(Drawer)
Vue.use(Link)

Vue.use(Loading.directive)

Vue.use(BasicTableComp)
Vue.use(BasicDrawerComp)

// Vue.use(AkeDialog)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message

Vue.use(waterfall)

function confirmFn(message = '', title = '', options = {}) {
  const opts = {
    confirmButtonText: '确 认',
    cancelButtonText: '取 消',
    ...options,
    customClass: `ake_confirm_wrapper ${options.customClass || ''}`,
  }
  return MessageBox.confirm(message, title, opts)
}

Vue.prototype.$akeConfirm = confirmFn
